import React from 'react';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M13.635 7.657c0 .27.106.527.298.719a1.044 1.044 0 0 0 1.441 0L17.7 6.05a1.011 1.011 0 0 0 0-1.441l-2.326-2.326a1.042 1.042 0 0 0-1.44 0 1.007 1.007 0 0 0-.299.72c0 .27.106.527.3.719l.588.589H8.836C5.066 4.31 2 7.379 2 11.148a6.843 6.843 0 0 0 6.836 6.836c3.346 0 6.252-2.493 6.757-5.796.002-.01.016-.115.016-.194l.002-.352a1.02 1.02 0 0 0-2.037 0v.189c0 .319-.117.658-.139.728-.628 1.969-2.51 3.388-4.599 3.388a4.804 4.804 0 0 1-4.8-4.8c0-2.645 2.153-4.8 4.8-4.8h5.687l-.589.59a1.01 1.01 0 0 0-.299.72"
});

var SvgReplayMinor = function SvgReplayMinor(props) {
  return React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), _ref);
};

export { SvgReplayMinor as S };